<template>
  <div class="details"><details-container/></div>
</template>

<script>
import DetailsContainer from '@/containers/Details'

export default {
  components: {
    DetailsContainer
  }
}
</script>

<style lang="scss" scoped>
  .details {
    width: 100%;

    @include media-up(md) {
      max-width: 575px;
    }

    position: fixed;
    top: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Details.vue